/*
* Try to login, check the login credentials, and then redirect if required.
*/
/*
* Get the `checkout_url` from the URL query parameter, if it exists.
* (It only ever exists on the /account/login page)
*/
function getCheckoutUrl() {  
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  return getParameterByName('checkout_url');
}


/*
* Or if you're registering a user:
*/
/*register(email, password, firstName, lastName).done(function (html) {
  
  // logic for registration errors
  if (html.indexOf('email is invalid') !== -1) {
     
  } else if html.indexOf('email can&#39;t be blank') !== -1) { 
    
  } else if (html.indexOf('password can&#39;t be blank.') !== -1) {
      
  }

});*/

(function($){

  $(document).ready(function(){
    videlxu.init();
  });
})(jQuery);
var videlxu = {
  error: function(title){
     $(".error-notify").html('<div class="alert alert-danger fade in">\
        <a href="#" class="close" data-dismiss="alert">&times;</a>\
        <strong>Error!</strong> '+title+'\
    </div>');
  },
  action: function(){
          $('.popup-failed').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: 'Close (Esc)',
        removalDelay: 500
      });
      $('.popup-modal').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        closeOnBgClick: false,
        closeBtnInside: false,
        closeOnContentClick: false,
        tClose: 'Close (Esc)',
        removalDelay: 500
      });
    
         $('.popup-modal-cart').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
            callbacks: {
      close: function(){
         window.location.href = "/checkout"; 
         }
 
    }
      });
    
    
    	$(document).on('click', '.popup-modal-customer', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
        
	});
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
      window.location.href = "https://www.bullsteel.com/"; 
        
	});

    $("#company_tel,input#zip").keydown(function (e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A, Command+A
          (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
          // Allow: home, end, left, right, down, up
          (e.keyCode >= 35 && e.keyCode <= 40)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
    
    /*
    
    $('form#customer_login').on('submit', function (e) {
      e.preventDefault();
      var email = $("input#CustomerEmail").val(),password = $("#CustomerPassword").val(),action = videlxu.readCookie("pathname");
      if(email === ""){videlxu.error("The <strong>Email</strong> field is empty");$("input#CustomerEmail").focus();return false;}
      if(password === ""){videlxu.error("The <strong>Password</strong> field is empty");$("input#CustomerPassword").focus();return false;}
      videlxu.login(email, password).done(function (html) {
        if(html.indexOf('Invalid login credentials') !== -1) {
          videlxu.error("Invalid login credentials");
          $('form#customer_login')[0].reset();
        } else {
          window.location.href = action;
          
        }
      }).fail(function(jqXHR, textStatus, errorThrown){
        
   //console.log(jqXHR.status);
  //  console.log(textStatus);
  //  console.log(errorThrown);
   // videlxu.error(errorThrown);

         videlxu.error(errorThrown);

    
});
    });
    
    */
  },
  validateEmail: function(email){
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  },
  login: function(email, password) {  
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };

    var promise = $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });

    return promise;
  },
  register:function(firstname,lastname,companyname,streetaddress,city,state,zip,company,companytel,email,password,where){
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      'customer[first_name]': firstname,
      'customer[last_name]': lastname,
      'customer[note][Company Name]': companyname,
      'customer[note][Street Address]': streetaddress,
      'customer[note][City]': city,
      'customer[note][State]': state,
      'customer[note][Zip]': zip,
      'customer[note][Company Website]': company,
      'customer[note][Company Tel #]': companytel,
      form_type: 'create_customer',
      utf8: '✓'
    };

    var promise = $.ajax({
      url: '/account',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true,
      success: function (data)
      {
       console.log(data);
        $('form#create_customer')[0].reset();
        $(".error-notify").html("");
        $(".popup-modal.open-sucess").trigger("click");
        videlxu.logout();
        where.removeAttr("disabled");
      },
      error: function (jqXHR, textStatus, errorThrown){
   		 console.log(jqXHR.status);
    	 console.log(textStatus);
    	 console.log(errorThrown);
      }
    });

    return promise;
  },
  logout:function(){
    $.ajax({
      url: '/account/logout',
      method: 'GET',
      dataType: 'html',
      async: true
    });
  },
  cookie:function(){
    var text = "/account/reset/";
    var pathname = window.location.href;
    if(pathname.indexOf(text) > -1){
    }else{
    if(pathname.match('^http://')){pathname = pathname.replace("http://","//");}
    if(pathname.match('^https://')){pathname = pathname.replace("https://","//");}
      
    if(pathname.indexOf('/products/') > -1){pathname = $('.body-main').attr('data-link');}
      if(pathname.indexOf('/collections/') > -1){pathname = $('.body-main').attr('data-link');}
      
    if(pathname.indexOf("/account/login") > -1){ 
if (localStorage) {
  var visits = localStorage.getItem('_redirect');

  if (visits == null) {
    localStorage.setItem('_redirect', true );
  }
  else{
    if(localStorage.getItem('_redirect') == "false"){
    localStorage.setItem('_redirect', true );
    }
  }
}
      return false;
    
    }
      if(pathname.indexOf("/challenge") > -1){ return false;}
    videlxu.createCpokie("pathname",pathname,1);
    }
  },
  createCpokie:function (key, value,exdays) {
    expires = new Date();
    expires.setTime(expires.getTime()+ (exdays*24*60*60*1000));cookie = key + '=' + value + ';expires=' + expires.toUTCString()+';path=/';
    return document.cookie = cookie;
  },
  readCookie:function (key) {
    keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    if (keyValue) {return keyValue[2];
                  }else{
                    return '/';}
  },
  setCookie:function (cname,cvalue,exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = 'expires=' + d.toGMTString();document.cookie = cname+'='+cvalue+'; '+expires+';path=/';
  },
  deleteCookie:function(cname){
      expires = new Date();expires.setTime(expires.getTime()+ (-1*24*60*60*1000));
      cookie = cname + '=;expires='+expires.toUTCString()+';path=/';
      return document.cookie = cookie;
  },
  captureemail: function(){
    
  $('#Email').on('input', function() {
  var inp = this;
  setTimeout(function() {
    localStorage.setItem('tosend_e', inp.value);
  }, 0);
});
  
  },
  popup:function(){
      var pathname = window.location.href;
    if(pathname.indexOf('register?contact') > -1){
       $(".popup-failed.open-sucess").trigger("click");
      
    }
      if(pathname.indexOf('register?customer_posted=true') > -1){

       var e_email = localStorage.getItem('tosend_e');
    
        $(".popup-modal.open-sucess").trigger("click");
              Email.send({
    SecureToken : "119e088f-68ef-4195-a6dc-d9865606e66c",
    To : 'john@bullsteel.com',
    From : "contact@bullsteelwebstore.com",
    Subject : "New customer application",
    Body : "New customer ("+e_email+") application needs to be reviewed. "
}).then(
  message => console.log(message)
);

  
      }
    
    
    if(pathname.indexOf('account/login?customer_posted=true') > -1) {
    
    $(".popup-modal.open-sucess").trigger("click");
      
      
      
    }
  },
  init: function(){
    this.captureemail();
    this.action();
    this.cookie();
    this.popup();
  }
}